import React, { useRef } from 'react'
import Profile from './profile'
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2'
const Contact = () => {

    const form = useRef();

    const sendEMail = (e) => {

        e.preventDefault();

        Swal.showLoading(Swal.getTimerProgressBar());

        emailjs.sendForm('service_4vzsexw', 'template_np472ou', form.current, 'uG0hBaBr7OY-xgiGR')
        
        .then((result) => {

            e.target.reset();

            Swal.fire({

                title: "Successfully!",
                text: "Your message has been sent",
                icon: 'success',

            })
        }, (error) => {
             Swal.fire({
                
                title: "Error!",
                text: "Something went wrong",
                icon: 'error',

            })
        });
    }

    const profile = {

        profileImage: 'assets/images/masoud-codes.gif',

        cv: 'assets/cv/CV_currently.pdf',
    
        background: 'assets/images/cc-bg-1.jpg',
    
        fullName: 'Sharifu .H. Masudi',
    
        age: new Date().getFullYear() - 1997,
    
        email: 'sharifumasudi66@gmail.com',
    
        phone: '+255622183130',
    
        altenateImage: "image profile",
    
        addres: 'P.O.BOX 3000, Morogoro Tanzania',
    
        language: 'English, Swahili',
    
        aboutTitle: 'Web Developer, System developer Graphic Designer,  Mobile App developer',
      }

  return (
    <>
        <Profile/>
        <div className="section" id="contact">
        <div className="container">
                <div className="cc-contact">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card mb-0" data-aos="zoom-in">
                            <div className="h4 text-center title">Contact Me</div>
                            <div className="row">
                            <div className="col-md-6">
                                <div className="card-body">
                                <form ref={form} onSubmit={sendEMail} method="POST">
                                    <div className="p pb-3"><strong>Feel free to contact me </strong></div>
                                    <div className="row mb-3">
                                    <div className="col">
                                        <div className="input-group"><span className="input-group-addon"><i className="fa fa-user-circle"></i></span>
                                        <input className="form-control" type="text" name="fullname" placeholder="Name" required="required"/>
                                        </div>
                                    </div>
                                    </div>
                                    <div className="row mb-3">
                                    <div className="col">
                                        <div className="input-group"><span className="input-group-addon"><i className="fa fa-envelope"></i></span>
                                        <input className="form-control" type="email" name="email" placeholder="E-mail" required="required"/>
                                        </div>
                                    </div>
                                    </div>
                                    <div className="row mb-3">
                                    <div className="col">
                                        <div className="input-group"><span className="input-group-addon"><i className="fa fa-phone"></i></span>
                                        <input className="form-control" type="text" name="phone" placeholder="Phone number" required="required"/>
                                        </div>
                                    </div>
                                    </div>
                                    <div className="row mb-3">
                                    <div className="col">
                                        <div className="form-group">
                                        <textarea className="form-control" name="message" placeholder="Your Message" required="required"></textarea>
                                        </div>
                                    </div>
                                    </div>
                                    <div className="row">
                                    <div className="col">
                                        <button className="btn btn-primary" type="submit">Send</button>
                                    </div>
                                    </div>
                                </form>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card-body">
                                <p className="mb-0"><strong>Address </strong></p>
                                <p className="pb-2">{profile.addres}</p>
                                <p className="mb-0"><strong>Phone</strong></p>
                                <p className="pb-2">{profile.phone}</p>
                                <p className="mb-0"><strong>Email</strong></p>
                                <p>{profile.email}</p>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div> 
    </>
  )
}

export default Contact
